(function () {
    "use strict";
    angular
        .module('skillBuilderSaaS')
        .directive("learningPathVersionStorefrontCrossSell", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningPaths/version/storefrontConfig/learningPathVersionStorefrontCrossSellView.html",
            controller: ["learningPathVersionStorefrontCrossSellResource", "$translate", "$stateParams", "$scope", "$timeout", "DTOptionsBuilder", "DTColumnDefBuilder", "DTDefaultOptions", "_", "messageService", "$uibModal", LearningPathVersionStorefrontCrossSellCtrl],
            controllerAs: "vm"
        };
        function LearningPathVersionStorefrontCrossSellCtrl(learningPathVersionStorefrontCrossSellResource, $translate, $stateParams, $scope, $timeout, DTOptionsBuilder, DTColumnDefBuilder, DTDefaultOptions, _, messageService, $uibModal) {
            var vm = this;
            DTDefaultOptions.setLoadingTemplate("<p class='text-center'><img src='/images/ajaxindicator.gif' class='control-label'></p>");
            vm.loading = true;
            vm.showErrors = false;
            vm.saving = false;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateDuration", -1)
                .withPaginationType("full_numbers")
                .withOption("order", [0, "asc"])
                .withOption("fnDrawCallback", function () {
                $timeout(function () {
                    vm.checkedAll = false;
                    //vm.clearSelection();
                    $scope.$apply();
                });
            })
                .withBootstrap();
            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(1).notSortable()
            ];
            vm.dtInstanceCallback = function (instance) {
                vm.dtInstance = instance;
            };
            vm.search = function (value) {
                vm.dtInstance.DataTable.search(value).draw();
            };
            //vm.addedCrossSellItems = $scope.$parent.vm.model.crossSellSuggestions;
            learningPathVersionStorefrontCrossSellResource.getStorefrontCrossSellList({ number: $stateParams.number, version: $stateParams.version }, function (data) {
                vm.addedCrossSellItems = data.selectedCrossSells;
                vm.updateList(data.crossSellSelections);
                vm.loading = false;
            }, function (errorData) {
                messageService.error(errorData);
            });
            vm.updateList = function (data) {
                vm.crossSellItems = _.filter(data, function (obj) {
                    return _.find(vm.addedCrossSellItems, { versionId: obj.versionId }) === undefined;
                });
            };
            vm.addCrossSell = function (crossSellVersion) {
                if (vm.addedCrossSellItems.length === 3) {
                    vm.showErrors = true;
                }
                else {
                    if (vm.saving)
                        return;
                    vm.saving = true;
                    learningPathVersionStorefrontCrossSellResource.addCrossSellItem({ number: $stateParams.number, version: $stateParams.version, value: crossSellVersion.versionId }, function () {
                        vm.saving = false;
                        vm.crossSellItems = _.without(vm.crossSellItems, crossSellVersion);
                        vm.addedCrossSellItems.push(crossSellVersion);
                        messageService.success("learningPath.storefront.crossSell.modal.addSuccess");
                    }, function (errorData) {
                        vm.saving = false;
                        messageService.error(errorData);
                    });
                }
            };
            vm.removeCrossSell = function (crossSellVersion) {
                var modal = $uibModal.open({
                    templateUrl: "deleteCrossSellConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    if (vm.saving)
                        return;
                    vm.saving = true;
                    learningPathVersionStorefrontCrossSellResource.removeCrossSellItem({ number: $stateParams.number, version: $stateParams.version, value: crossSellVersion.versionId }, function () {
                        vm.showErrors = false;
                        vm.saving = false;
                        vm.addedCrossSellItems = _.without(vm.addedCrossSellItems, crossSellVersion);
                        //$scope.$parent.vm.model.crossSellSuggestions = vm.addedCrossSellItems;
                        if (crossSellVersion.isPublished && crossSellVersion.isStorefrontEnabled)
                            vm.crossSellItems.push(crossSellVersion);
                        messageService.success("learningPath.storefront.crossSell.modal.removeSuccess");
                    }, function (errorData) {
                        messageService.error(errorData);
                    });
                });
            };
        }
    });
}());
